import { ReactComponent as PausedStatusIcon } from 'assets/PausedStatusIcon.svg';

interface IPausedOfferStatusProps {
  iconClassName?: string;
  labelClassName?: string;
}

const PausedOfferStatus: React.FC<IPausedOfferStatusProps> = ({
  iconClassName = 'w-4 h-4 flex-shrink-0 mb-[2px]',
  labelClassName = 'text-orange font-medium',
}) => (
  <div className="text-darkBlue text-base flex gap-1 flex-row items-center">
    <PausedStatusIcon className={iconClassName} aria-hidden />
    <span className="text-black opacity-60">Status: </span>
    <span className={labelClassName}>Paused</span>
  </div>
);

export default PausedOfferStatus;
